<template>
    <v-app class="quiz-root">
        <!-- Barra estilo WhatsApp -->
        <v-app-bar app color="#128C7E" :height="$vuetify.breakpoint.smAndUp ? 90 : 60" dark flat>
            <img
                src="@/assets/images/whataspp-desktop.svg"
                width="140"
                class="ml-4"
            />
            <v-spacer></v-spacer>
        </v-app-bar>

        <!-- Conteúdo -->
        <v-container
            fluid
            class="d-flex align-center justify-center"
            style="min-height: 100vh; background: #f0f4f9;"
        >
            <v-card
                class="d-flex flex-column justify-center align-center"
                style="height: 100%; width: 900px; background: white;"
                elevation="0"
                light
            >
                <!-- Logo ZaperMenu -->
                <div v-if="step === 0" class="text-center" style="max-width: 460px;">
                    <v-avatar size="120" class="mb-4">
                        <img src="@/assets/images/zapermenu-profile.png" alt="ZaperMenu" />
                    </v-avatar>
                    <h2>
                        ZaperMenu
                        <v-icon color="green">mdi-check-decagram</v-icon>
                    </h2>

                    <!-- Lead que já concluiu o quiz em outra visita -->
                    <template v-if="jaEnviou">
                        <div class="retorno-selo mt-3">
                            <v-icon small color="#128C7E" class="mr-1">mdi-check-circle</v-icon>
                            Você já falou com a gente em {{ dataDoEnvio }}
                        </div>
                        <p class="mt-3">
                            {{ primeiroNomeSalvo ? primeiroNomeSalvo + ', s' : 'S' }}uas respostas já estão
                            com o time de revenda 🙌<br />
                            É só continuar a conversa por onde paramos.
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="abrirWhatsappSemNovoLead"
                        >
                            <v-icon left>mdi-whatsapp</v-icon>
                            Abrir a conversa
                        </v-btn>
                        <div>
                            <v-btn text small color="grey darken-1" class="mt-3 text-none" @click="atualizarInformacoes">
                                <v-icon small class="mr-1">mdi-pencil</v-icon>
                                Atualizar minhas informações
                            </v-btn>
                        </div>
                    </template>

                    <!-- Lead que parou no meio em outra visita -->
                    <template v-else-if="temProgressoSalvo">
                        <div class="retorno-selo mt-3">
                            <v-icon small color="#128C7E" class="mr-1">mdi-content-save-check</v-icon>
                            Progresso salvo
                        </div>
                        <p class="mt-3">
                            Que bom te ver de novo{{ primeiroNomeSalvo ? ', ' + primeiroNomeSalvo : '' }}! 👋<br />
                            Você já tinha começado — quer continuar de onde parou?
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="continuarDeOndeParei"
                        >
                            Continuar de onde parei
                        </v-btn>
                        <div>
                            <v-btn text small color="grey darken-1" class="mt-3 text-none" @click="recomecarDoZero">
                                <v-icon small class="mr-1">mdi-restart</v-icon>
                                Recomeçar do início
                            </v-btn>
                        </div>
                    </template>

                    <!-- Primeira visita -->
                    <template v-else>
                        <p class="mt-2">
                            👋 Olá! Sou o assistente do ZaperMenu.<br />
                            Vamos conhecer um pouco do seu trabalho pra te apresentar o programa de revenda 🚀
                        </p>
                        <p class="mt-2 caption">
                            Toque no botão abaixo para começar
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="nextQuestion"
                        >
                            Começar
                        </v-btn>
                    </template>
                </div>

                <!-- Etapas -->
                <transition :name="transitionName" mode="out-in">
                    <v-card
                        v-if="currentQuestion && step > 0 && step <= questions.length"
                        :key="currentQuestion.id"
                        class="pa-6"
                        width="500"
                        elevation="2"
                    >
                        <div class="text-left">
                            <div class="text-caption grey--text mb-2">
                                Etapa {{ step }} de {{ questions.length }}
                            </div>
                            <h3 class="mb-2">{{ currentQuestion.title }}</h3>
                            <p v-if="currentQuestion.description" class="grey--text text--darken-1">
                                {{ currentQuestion.description }}
                            </p>
                        </div>

                        <div class="mt-4 text-left">
                            <!-- Única escolha -->
                            <div v-if="currentQuestion.type === 'single'">
                                <v-btn-toggle
                                    v-model="answers[currentQuestion.id]"
                                    class="flex-wrap opcoes"
                                    style="max-height: 350px; overflow-x: auto;"
                                >
                                    <v-btn
                                        v-for="opt in currentQuestion.options"
                                        :key="opt"
                                        :value="opt"
                                        outlined
                                        color="#128C7E"
                                        class="ma-1 text-none"
                                        style="border: 1px solid;"
                                        @click="selectSingleOption(opt)"
                                    >
                                        {{ opt }}
                                    </v-btn>
                                </v-btn-toggle>

                                <v-text-field
                                    v-if="pedeComplemento(currentQuestion)"
                                    v-model="answers[currentQuestion.complemento.id]"
                                    :placeholder="currentQuestion.complemento.placeholder"
                                    outlined
                                    dense
                                    hide-details
                                    autofocus
                                    class="mt-3"
                                />
                            </div>

                            <!-- Texto curto -->
                            <v-text-field
                                v-else-if="currentQuestion.type === 'text'"
                                v-model="answers[currentQuestion.id]"
                                :placeholder="currentQuestion.placeholder"
                                outlined
                                dense
                                hide-details
                                class="mt-3"
                            />

                            <!-- Telefone -->
                            <v-text-field
                                v-else-if="currentQuestion.type === 'tel'"
                                v-model="answers[currentQuestion.id]"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                :placeholder="currentQuestion.placeholder"
                                outlined
                                dense
                                type="tel"
                                hide-details
                                class="mt-3"
                            />
                        </div>

                        <v-progress-linear
                            :value="progress"
                            color="#128C7E"
                            height="6"
                            rounded
                            class="my-5"
                        />

                        <v-row dense>
                            <v-col cols="6">
                                <v-btn
                                    v-if="step > 1"
                                    outlined
                                    color="#128C7E"
                                    rounded
                                    large
                                    block
                                    @click="prevQuestion"
                                >
                                    Voltar
                                </v-btn>
                            </v-col>

                            <v-col cols="6">
                                <v-btn
                                    color="#128C7E"
                                    class="white--text"
                                    rounded
                                    large
                                    block
                                    @click="nextQuestion"
                                    :disabled="!isAnswered"
                                >
                                    {{ isLastStep ? 'Finalizar' : 'Próxima' }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Tela final -->
                    <v-card
                        v-else-if="step > questions.length"
                        key="finish"
                        width="500"
                        class="pa-6 text-center"
                        elevation="2"
                    >
                        <v-icon color="#128C7E" size="60">mdi-whatsapp</v-icon>
                        <h3 class="mt-3">
                            Perfeito, {{ primeiroNome }}!
                        </h3>

                        <template v-if="enviando">
                            <p class="mt-2">
                                Estamos abrindo o WhatsApp do time de revenda 🚀
                            </p>
                            <v-progress-circular indeterminate color="#128C7E" size="40" class="my-4" />
                        </template>

                        <template v-else>
                            <p class="mt-2">
                                A mensagem já vai escrita com as suas respostas.<br />
                                É só enviar para falar com o time de revenda 🚀
                            </p>
                            <v-btn
                                color="#128C7E"
                                dark
                                rounded
                                large
                                class="mt-3"
                                @click="abrirConversaWhatsapp"
                            >
                                <v-icon left>mdi-whatsapp</v-icon>
                                Abrir o WhatsApp
                            </v-btn>
                        </template>
                    </v-card>
                </transition>
            </v-card>
        </v-container>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { trackEvent, trackLeadMeta } from '@/utils/track';
import { uuidDaResposta } from '@/utils/api';
import { urlConversaWhatsapp } from '@/utils/conversaWhatsapp';
import { cookiesMeta } from '@/utils/attribution';
import { VERSAO_QUIZ_REVENDA } from '@/store';
import {
  trackQuizInicio,
  trackQuizResposta,
  trackQuizCompleto,
  trackLeadCriado,
  trackClick,
} from '@/utils/lpTracker';

const QUIZ_ID = 'revenda';

/** Mesmo prazo do quiz do /whatsapp: resposta mais antiga é descartada. */
const VALIDADE_QUIZ_DIAS = 90;

/**
 * Rótulo da tela → código gravado no `contatos.metadata`. Os rótulos são as
 * opções da pergunta; os códigos são validados em App\Support\LeadMetadata
 * (REVENDA_*) na API e traduzidos de volta no `leadOptions.js` do control.
 */
const ATUACAO = {
    'Agência de marketing ou social media': 'AGENCIA_MARKETING',
    'Consultoria para restaurantes': 'CONSULTORIA',
    'Vendo maquininha ou meios de pagamento': 'MEIOS_PAGAMENTO',
    'Vendo sistemas ou equipamentos (PDV, impressora)': 'SISTEMAS_EQUIPAMENTOS',
    'Representante comercial (bebidas, alimentos, embalagens)': 'REPRESENTANTE_COMERCIAL',
    'Contabilidade': 'CONTABILIDADE',
    'Tenho restaurante ou delivery': 'DONO_RESTAURANTE',
    'Outro': 'OUTRO',
};

const CONTATOS = {
    'Nenhum ainda': 'NENHUM',
    '1 a 10': 'ATE_10',
    '11 a 50': 'DE_11_A_50',
    'Mais de 50': 'ACIMA_50',
};

const SISTEMA = {
    'Sim, de outra empresa': 'VENDE_OUTRO',
    'Já vendi, hoje não': 'JA_VENDEU',
    'Não, seria o primeiro': 'NUNCA_VENDEU',
};

const DEDICACAO = {
    'É (ou vai ser) minha atividade principal': 'PRINCIPAL',
    'Algumas horas por semana, como renda extra': 'RENDA_EXTRA',
    'Só quero indicar quando aparecer alguém': 'SO_INDICAR',
};

const CNPJ = {
    'Sim': 'SIM',
    'Sou MEI': 'MEI',
    'Ainda não': 'NAO',
};

/**
 * `resumo` é o rótulo da linha na mensagem que o lead envia ao time de revenda
 * (em primeira pessoa: quem envia é ele). `complemento` é o campo de texto que
 * aparece quando a opção marcada pede detalhe.
 */
const PERGUNTAS = [
    {
        id: 'atuacao',
        title: 'O que você faz hoje?',
        description: 'Escolha a opção mais próxima da sua atividade 💼',
        type: 'single',
        codigos: ATUACAO,
        complemento: { quando: 'Outro', id: 'atuacao_outro', placeholder: 'Qual é a sua atividade?' },
        resumo: 'O que faço hoje',
    },
    {
        id: 'contatos',
        title: 'Com quantos restaurantes, lanchonetes ou deliveries você já tem contato?',
        description: 'Clientes, parceiros ou conhecidos do ramo 🍽️',
        type: 'single',
        codigos: CONTATOS,
        resumo: 'Restaurantes com quem tenho contato',
    },
    {
        id: 'sistema',
        title: 'Você já vende algum sistema para restaurantes?',
        type: 'single',
        codigos: SISTEMA,
        complemento: { quando: 'Sim, de outra empresa', id: 'sistema_qual', placeholder: 'Qual sistema?' },
        resumo: 'Já vendo sistema para restaurantes',
    },
    {
        id: 'dedicacao',
        title: 'Quanto tempo você quer dedicar à revenda?',
        type: 'single',
        codigos: DEDICACAO,
        resumo: 'Tempo para a revenda',
    },
    {
        id: 'regiao',
        title: 'Em qual cidade ou região você vai atuar?',
        type: 'text',
        placeholder: 'Ex.: Chapecó/SC',
        resumo: 'Região de atuação',
    },
    {
        id: 'cnpj',
        title: 'Você tem CNPJ?',
        type: 'single',
        codigos: CNPJ,
        resumo: 'CNPJ',
    },
    {
        id: 'nome',
        title: 'Qual é o seu nome?',
        type: 'text',
        placeholder: 'Digite seu nome',
    },
    {
        id: 'whatsapp',
        title: 'Qual o seu número de WhatsApp?',
        type: 'tel',
        placeholder: '(99) 99999-9999',
    },
].map(q => (q.codigos ? { ...q, options: Object.keys(q.codigos) } : q));

export default {
    name: 'RevendaWhatsapp',

    data: () => ({
        step: 0,
        direction: 'next',
        enviando: false,
        // Lead que já enviou e escolheu revisar: libera o quiz sem apagar o
        // registro do envio anterior.
        revisandoEnvio: false,
        answers: {},
        questions: PERGUNTAS,
    }),

    created() {
        this.restaurarRespostasSalvas();
    },

    computed: {
        ...mapState([
            'quizRevenda',
            'urlParams',
        ]),

        /** Respostas salvas de uma visita anterior, já validadas. */
        respostasSalvas() {
            const salvo = this.quizRevenda;

            if (!salvo || salvo.versao !== VERSAO_QUIZ_REVENDA) return null;
            if (!salvo.salvoEm) return null;
            if ((Date.now() - salvo.salvoEm) > VALIDADE_QUIZ_DIAS * 24 * 60 * 60 * 1000) return null;

            return salvo.respostas && Object.keys(salvo.respostas).length ? salvo.respostas : null;
        },

        temProgressoSalvo() {
            return !!this.respostasSalvas && Object.keys(this.higienizar(this.respostasSalvas)).length > 0;
        },

        jaEnviou() {
            if (this.revisandoEnvio) return false;
            return !!(this.quizRevenda && this.quizRevenda.enviadoEm);
        },

        primeiroNome() {
            return this.answers.nome ? String(this.answers.nome).trim().split(' ')[0] : '';
        },

        primeiroNomeSalvo() {
            const nome = this.answers.nome || (this.respostasSalvas && this.respostasSalvas.nome);
            return nome ? String(nome).trim().split(' ')[0] : '';
        },

        dataDoEnvio() {
            if (!this.jaEnviou) return '';

            const d = new Date(this.quizRevenda.enviadoEm);
            const dia = String(d.getDate()).padStart(2, '0');
            const mes = String(d.getMonth() + 1).padStart(2, '0');

            return `${dia}/${mes}`;
        },

        transitionName() {
            return this.direction === 'next' ? 'slide-left' : 'slide-right';
        },

        currentQuestion() {
            return this.questions[this.step - 1];
        },

        progress() {
            return (this.step / this.questions.length) * 100;
        },

        isLastStep() {
            return this.step === this.questions.length;
        },

        isAnswered() {
            return this.respondida(this.currentQuestion);
        },

        /**
         * As respostas, uma por linha, abaixo da mensagem do WhatsApp: o número de
         * revenda não está no ChatPro, então é por aqui que o time lê a qualificação.
         */
        resumoParaWhatsapp() {
            const linhas = this.answers.nome ? [`Nome: ${String(this.answers.nome).trim()}`] : [];

            this.questions.forEach((q) => {
                const valor = this.textoDaResposta(q);
                if (q.resumo && valor) linhas.push(`${q.resumo}: ${valor}`);
            });

            return linhas.join('\n');
        },
    },

    methods: {
        pedeComplemento(q) {
            return !!q.complemento && this.answers[q.id] === q.complemento.quando;
        },

        /** Resposta como aparece na mensagem: "Outro (personal trainer)". */
        textoDaResposta(q) {
            const valor = this.answers[q.id];
            if (!valor) return '';

            const texto = String(valor).trim();
            if (!this.pedeComplemento(q)) return texto;

            const extra = String(this.answers[q.complemento.id] || '').trim();
            return extra ? `${texto} (${extra})` : texto;
        },

        /**
         * Descarta valor salvo que não existe mais nas opções atuais — o que é
         * gravado é o RÓTULO, e rótulo muda. Mesmo motivo do quiz do /whatsapp.
         */
        higienizar(respostas) {
            const limpo = {};

            this.questions.forEach((q) => {
                const valor = respostas ? respostas[q.id] : null;

                if (valor === null || valor === undefined || valor === '') return;
                if (q.type === 'single' && q.options.indexOf(valor) === -1) return;

                limpo[q.id] = valor;

                if (q.complemento && valor === q.complemento.quando && respostas[q.complemento.id]) {
                    limpo[q.complemento.id] = respostas[q.complemento.id];
                }
            });

            return limpo;
        },

        restaurarRespostasSalvas() {
            if (!this.respostasSalvas) return;

            this.answers = { ...this.answers, ...this.higienizar(this.respostasSalvas) };
        },

        persistirRespostas() {
            this.$store.commit('salvarQuizRevenda', { ...this.answers });
        },

        respondida(q) {
            if (!q) return false;

            const val = this.answers[q.id];

            if (q.type === 'tel') {
                return !!val && val.replace(/\D/g, '').length >= 10;
            }

            if (this.pedeComplemento(q)) {
                const extra = this.answers[q.complemento.id];
                return !!(extra && extra.trim().length >= 2);
            }

            return typeof val === 'string' ? val.trim().length > 0 : !!val;
        },

        /** Índice (1-based) da primeira pergunta ainda em branco. */
        primeiraPerguntaEmBranco() {
            for (let i = 0; i < this.questions.length; i++) {
                if (!this.respondida(this.questions[i])) return i + 1;
            }

            // Tudo respondido: para na última, que é a que envia.
            return this.questions.length;
        },

        continuarDeOndeParei() {
            trackQuizInicio(QUIZ_ID);
            trackClick('Quiz Revenda - continuou de onde parou');

            this.direction = 'next';
            this.$nextTick(() => {
                this.step = this.primeiraPerguntaEmBranco();
            });
        },

        recomecarDoZero() {
            trackClick('Quiz Revenda - recomecou do zero');

            this.$store.commit('limparQuizRevenda');
            this.answers = {};
            this.revisandoEnvio = false;

            trackQuizInicio(QUIZ_ID);
            this.direction = 'next';
            this.step = 1;
        },

        /** Lead que já enviou e só quer voltar à conversa: sem POST, sem lead novo. */
        abrirWhatsappSemNovoLead() {
            trackClick('Quiz Revenda - reabertura sem novo lead');
            this.abrirConversaWhatsapp();
        },

        /** Lead já enviado que quer corrigir algo: revisa as respostas e reenvia. */
        atualizarInformacoes() {
            trackClick('Quiz Revenda - atualizar informacoes');

            this.revisandoEnvio = true;
            trackQuizInicio(QUIZ_ID);
            this.direction = 'next';
            this.step = 1;
        },

        abrirConversaWhatsapp() {
            window.open(urlConversaWhatsapp('revenda', this.resumoParaWhatsapp), '_blank');
        },

        selectSingleOption(opt) {
            const q = this.currentQuestion;

            this.$set(this.answers, q.id, opt);

            if (q.complemento && opt !== q.complemento.quando) {
                this.$delete(this.answers, q.complemento.id);
            }

            this.$nextTick(() => {
                // Clicar de novo na opção marcada a desmarca (v-btn-toggle): não avança.
                if (!this.answers[q.id]) return;
                // "Outro" e "Sim, de outra empresa" esperam o texto do complemento.
                if (this.pedeComplemento(q)) return;
                this.nextQuestion();
            });
        },

        nextQuestion() {
            this.direction = 'next';

            if (this.step === 0) {
                trackQuizInicio(QUIZ_ID);
                this.step++;
                return;
            }

            if (this.currentQuestion) {
                trackQuizResposta(
                    QUIZ_ID,
                    this.step,
                    this.currentQuestion.title,
                    this.answers[this.currentQuestion.id],
                );

                // Grava agora, não no fim: quem fecha a aba no meio volta de onde parou.
                this.persistirRespostas();
            }

            if (this.isLastStep) {
                return this.finish();
            }

            this.step++;
        },

        prevQuestion() {
            this.direction = 'prev';

            if (this.step > 1) {
                this.step--;
            }
        },

        finish() {
            this.step++;
            this.enviando = true;

            const a = this.answers;
            const porId = {};
            this.questions.forEach((q) => { porId[q.id] = q; });

            const codigo = id => porId[id].codigos[a[id]] || null;
            const complemento = (id) => {
                const q = porId[id];
                return this.pedeComplemento(q) ? String(a[q.complemento.id] || '').trim() || null : null;
            };

            const metaCookies = cookiesMeta();

            const data = {
                nome: String(a.nome).trim(),
                whatsapp: '55' + a.whatsapp.replace(/\D/g, ''),
                produto: 'revenda',
                revenda_atuacao: codigo('atuacao'),
                revenda_atuacao_outro: complemento('atuacao'),
                revenda_contatos: codigo('contatos'),
                revenda_sistema: codigo('sistema'),
                revenda_sistema_qual: complemento('sistema'),
                revenda_dedicacao: codigo('dedicacao'),
                revenda_regiao: String(a.regiao).trim(),
                revenda_cnpj: codigo('cnpj'),

                // Atribuição resolvida pelo [src/utils/attribution.js], igual ao quiz do
                // /whatsapp. Sem `indicacao_empresa_id`: o Indique e Ganhe é do lojista
                // que indica restaurante, não de quem quer revender.
                anuncio_uuid: this.urlParams.ad,
                origem: this.urlParams.origem || this.urlParams.utm,
                origem_fonte: this.urlParams.fonte || null,
                origem_primeira: this.urlParams.primeiro ? this.urlParams.primeiro.origem : null,
                anuncio_uuid_primeiro: this.urlParams.primeiro ? this.urlParams.primeiro.ad : null,
                visitante_uuid: this.urlParams.visitante_uuid || null,
                utm_params: this.urlParams.utm_params || null,

                // Conversions API da Meta: cookies do pixel e a página do cadastro.
                meta_fbp: metaCookies.fbp,
                meta_fbc: metaCookies.fbc,
                meta_event_source_url: window.location.href,
            };

            this.$http.post('contato', data).then((res) => {
                const uuid = uuidDaResposta(res);

                if (uuid) {
                    // Mesmo event_id do Lead que o servidor manda (deduplicação da Meta).
                    trackLeadMeta(uuid, { content_name: 'quiz revenda' });

                    this.$store.commit('marcarQuizRevendaEnviado', uuid);

                    trackLeadCriado(uuid);
                    trackQuizCompleto(QUIZ_ID, uuid);
                } else {
                    console.warn('[quiz revenda] POST /contato sem uuid na resposta', res && res.data);
                    this.$store.commit('marcarQuizRevendaEnviado', null);
                }
            }).finally(() => {
                trackEvent('AddToCart', 'add_to_cart', { content_name: 'quiz revenda' });
                trackEvent('Contact',   'contact',     { content_name: 'quiz revenda' });

                this.enviando = false;
                this.abrirConversaWhatsapp();
            });
        },
    },
};
</script>

<style scoped>
.quiz-root {
    background-color: #f0f4f9;
    font-family: 'Roboto', sans-serif;
}

.retorno-selo {
    display: inline-flex;
    align-items: center;
    background: #e7f5f2;
    color: #0f6e63;
    border: 1px solid #b7e0d8;
    border-radius: 999px;
    padding: 4px 14px;
    font-size: 13px;
    font-weight: 500;
}

/* Opções longas ("Representante comercial (bebidas, ...)") quebram linha em vez de cortar. */
.opcoes .v-btn {
    height: auto !important;
    min-height: 36px;
    max-width: calc(100% - 8px); /* desconta a margem do ma-1 */
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

.opcoes ::v-deep .v-btn__content {
    white-space: normal;
    flex: 1 1 auto;
    text-align: left;
    line-height: 1.3;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.2s ease;
    position: relative;
}

.slide-left-enter,
.slide-right-leave-to {
    opacity: 0;
    transform: translateX(40px);
}

.slide-left-leave-to,
.slide-right-enter {
    opacity: 0;
    transform: translateX(-40px);
}

.pulse-button {
    position: relative;
    overflow: hidden;
    animation: pulseGlow 2.4s ease-in-out infinite;
    background-color: #128C7E !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 0 0 rgba(18, 140, 126, 0.3);
    font-weight: 600;
    letter-spacing: 0.5px;
}

.pulse-button:hover {
    transform: scale(1.07);
    box-shadow: 0 0 20px rgba(18, 140, 126, 0.4);
}

@keyframes pulseGlow {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0.45);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 10px rgba(18, 140, 126, 0.0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0);
    }
}

.pulse-button::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.pulse-button:hover::after {
    opacity: 1;
}
</style>
